import WebSocketService from "./websocketService";
import messageRouter from "./websocketRouter";

class WebSocketController {
    constructor() {
        this.webSocketService = new WebSocketService(process.env.REACT_APP_API_WEBSOCKET_URL);
        this.isAuthenticated = false;
        this.authTimeout = null;
    }

    setUpMessageHandler() {
        this.webSocketService.setOnMessageHandler(this.handleMessage.bind(this));
    }

    async handleMessage(event) {
        const message = JSON.parse(event.data);
        if (message.type === 'authenticate') {
            await this.handleAuthentication(message);
        } else {
            // const { default: messageRouter } = await import("./websocketRouter");
            await messageRouter(this, message);
        }
    }

    async handleAuthentication(message) {
        if (message.status === "success") {
            this.isAuthenticated = true;
            console.log("Success authenticate websocket connection");
            this.clearAuthTimeout();
        } else {
            console.error("Authenticate error: ", message.error);
            await this.handleAuthFailure();
        }
    }

    startAuthTimeout() {
        this.authTimeout = setTimeout(async () => {
            if (!this.isAuthenticated) {
                console.error("Authenticated timeout, closing connection");
                await this.handleAuthFailure();
            }
        }, 5000);
    }

    clearAuthTimeout() {
        clearTimeout(this.authTimeout);
        this.authTimeout = null;
        // if (this.isAuthenticated) {
        //     clearTimeout(this.authTimeout);
        //     this.authTimeout = null;
        // }
    }

    async handleAuthFailure() {
        console.log("Reconecting...");
        await this.reconnect();
    }

    getToken() {
        return localStorage.getItem('authToken');
    }

    async disconnect() {
        this.webSocketService.setToken(null);
        await this.webSocketService.disconnect();
    }

    async reconnect() {
        await this.disconnect();
        await this.connect();
    }

    async connect() {
        const token = this.getToken();
        if (!token) {
            console.warn("No token");
            return;
        }
        this.webSocketService.setToken(token);
        await this.webSocketService.connect();
        this.setUpMessageHandler();
        this.startAuthTimeout();
    }

    async start() {
        await this.connect();
    }
}

const WebsocketController = new WebSocketController();
export default WebsocketController;